module.exports = __webpack_public_path__ + "img/light-Path 18 Copy@3x.dafd179b.png";